"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBlockField = isBlockField;

function isBlockField(field) {
  return field.type === 'array' && field.of && field.of.some(member => member.type === 'block');
}